import script from "./OrderCenter.vue?vue&type=script&setup=true&lang=js"
export * from "./OrderCenter.vue?vue&type=script&setup=true&lang=js"

import "./OrderCenter.vue?vue&type=style&index=0&id=68626f5a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-68626f5a"]])

export default __exports__